import { Alert, AlertDescription, Box, Button, HStack, VStack } from '@chakra-ui/react';
import { usePropertiesModel } from '@common/models/PropertiesModel';
import { FontFamily } from '@common/theming/Fonts';
import currency from '@common/utility/currency';
import { SFRPropertyStatus } from '@services/appsync/types';
import React from 'react';
import { Link } from 'react-router-dom';
import { TextBlock } from 'src/apps/invest/common/components/TextBlock';
import { ROUTES } from 'src/apps/invest/config';

type NonAccreditedSlotsFullProps = {
  children?: React.ReactNode;
};

export const NonAccreditedSlotsFull: React.FC<NonAccreditedSlotsFullProps> = () => {
  const { property } = usePropertiesModel();
  const totalPropertyAmount = Number(property?.target_amount ?? 0);

  let totalInvestors = Number(property?.investor_count?.total);
  if (isNaN(totalInvestors)) totalInvestors = 0;

  const currentAmountRaised = Number(property?.raised_amount?.total ?? 0);
  const fundedPercent = (currentAmountRaised / totalPropertyAmount) * 100;
  const fullyFunded = property?.sfr?.status.status === SFRPropertyStatus.SOLD_OUT;

  return (
    <VStack gap={5} alignItems={'flex-start'} justifyItems={'flex-start'} w="full">
      <HStack alignItems={'flex-end'}>
        <TextBlock fontSize={'40px'} fontFamily={FontFamily.HELVETICA_NOW_BOLD} lineHeight={1}>
          {currency.format(totalPropertyAmount ?? 0, { maximumFractionDigits: 0 })}
        </TextBlock>
        <TextBlock fontSize={'16px'} color="gray.600">
          RAISED
        </TextBlock>
      </HStack>

      <Box backgroundColor="gray.100" borderRadius={15} h={15} w={'full'}>
        <Box background={'gray.500'} borderRadius={15} h={15} w={`100%`}></Box>
      </Box>
      <HStack gap="32px">
        <HStack justifyItems={'flex-start'} alignItems={'flex-end'}>
          <TextBlock fontSize={'24px'} fontFamily={FontFamily.HELVETICA_NOW_BOLD} lineHeight={1}>
            {totalInvestors}
          </TextBlock>
          <TextBlock fontSize={'16px'} color="gray.600">
            {Number(totalInvestors) === 1 ? 'INVESTOR' : 'INVESTORS'}
          </TextBlock>
        </HStack>
        <HStack justifyItems={'flex-start'} alignItems={'flex-end'}>
          <TextBlock fontSize={'24px'} weight="bold" lineHeight={1}>
            {fullyFunded ? 100 : fundedPercent.toFixed(0)}%
          </TextBlock>
          <TextBlock fontSize={'16px'} color="gray.600">
            {'RAISED'}
          </TextBlock>
        </HStack>
      </HStack>
      <Box
        background={`gray.300`}
        borderRadius={'5px'}
        color={'white'}
        fontFamily={FontFamily.HELVETICA_NOW_BOLD}
        fontSize={'18px'}
        lineHeight={'60px'}
        textAlign={'center'}
        w={'full'}>
        Non-accredited Slots Full
      </Box>

      <Alert status="warning">
        <AlertDescription>
          We're sorry but all non-accredited investor slots are full. If you're an accredited investor update your{' '}
          <Button color={'yellow.700'} as={Link} variant="link" to={ROUTES.profile + '#exit-timing'}>
            Accredition Form
          </Button>{' '}
          in your Investor Profile, come back and you should be able to invest.
        </AlertDescription>
      </Alert>
    </VStack>
  );
};
